export default __webpack_public_path__ + "static/media/Initiate's Leggings of the Forbidden Art.5ee7e721.jpg";